const hasTransparentHeader = document.querySelector('.hasTransparentHeader');
const header = document.querySelector('.Header');

if (hasTransparentHeader && header) {
    header.classList.add('Header--transparent');
}
